export const RelayItemsPerPageMobile = 30
